import React from 'react';

const Payment = () => {
    return (
        <div className="centerized-text">
            <h4>Payment System Will Add Soon</h4>.
        </div>
    );
};

export default Payment;